// extracted by mini-css-extract-plugin
module.exports = {"current-day":"styles_current-day__TeTyO","calendar":"styles_calendar__50LVV","MuiDayCalendar-weekDayLabel":"styles_MuiDayCalendar-weekDayLabel__8DHqQ"};